var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.476,
    height: 14.476,
    viewBox: "0 0 14.476 14.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041C\\u0435\\u0434\\u0438\\u0446\\u0438\\u043D\\u0430",
    d: "M9.509,14.476H4.967a.424.424,0,0,1-.424-.424V9.933H.424A.424.424,0,0,1,0,9.509V4.967a.424.424,0,0,1,.424-.424H4.543V.424A.424.424,0,0,1,4.967,0H9.509a.424.424,0,0,1,.424.424V4.543h4.119a.424.424,0,0,1,.424.424V9.509a.424.424,0,0,1-.424.424H9.933v4.119A.424.424,0,0,1,9.509,14.476Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/Medicine.fec71ac0c2420d69bb8beab40f979077.svg";
export { ForwardRef as ReactComponent };